<template>
  <div class="data-form">
    <div class="look-form" v-if='pageId == 1'>
      <div class="look-form-item" :class="subMitFlag == true && formData.name == '' ? 'look-form-item-hover' : '' ">
        <input type="text" placeholder="房东姓名" v-model="formData.name">
      </div>
      <div class="look-form-item" :class="subMitFlag == true && formData.phone == '' ? 'look-form-item-hover' : '' " >
        <input type="number" :placeholder="phoneText" v-model="formData.phone">
      </div>
      <div class="look-form-item" :class="subMitFlag == true && formData.address == '' ? 'look-form-item-hover' : ''  " @click="addressClick(0)">
        <input type="text" placeholder="商铺位置" v-model="formData.address" readonly="readonly">
      </div>
      <div class="look-form-item" :class="subMitFlag == true && formData.acreage == '' ? 'look-form-item-hover' : ''  ">
        <input type="number" placeholder="意向面积" v-model="formData.acreage">
      </div>
      <van-button @click="formSubmit" v-if=" formLoadFlag == true">免费提交</van-button>
      <van-button v-if=" formLoadFlag == false" loading type="info" loading-text="提交中..."/>
    </div>

    <div class="look-form" v-if='pageId == 2'>
      <div class="look-form-item" :class="subMitFlag == true && formData.name == '' ? 'look-form-item-hover' : '' ">
        <input type="text" placeholder="您的姓名" v-model="formData.name">
      </div>
      <div class="look-form-item" :class="subMitFlag == true && formData.phone == '' ? 'look-form-item-hover' : '' " >
        <input type="number" :placeholder="phoneText" v-model="formData.phone">
      </div>
      <div class="look-form-item" :class="subMitFlag == true && formData.area == '' ? 'look-form-item-hover' : ''  " @click="addressClick(0)">
        <input type="text" placeholder="求租区域" v-model="formData.area" readonly="readonly">
      </div>
      <div class="look-form-item" :class="subMitFlag == true && formData.acreage == '' ? 'look-form-item-hover' : ''  ">
        <input type="number" placeholder="意向面积" v-model="formData.acreage">
      </div>
      <div class="look-form-item" :class="subMitFlag == true && formData.suitableForFormats == '' ? 'look-form-item-hover' : ''  " @click="addressClick(1)">
        <input type="text" placeholder="经营业态" v-model="formData.suitableForFormats" readonly="readonly">
      </div>
      <van-button @click="formSubmit" v-if=" formLoadFlag == true">免费提交</van-button>
      <van-button v-if=" formLoadFlag == false" loading type="info" loading-text="提交中..."/>
    </div>

    <div class="form-info">
      <div class="form-text ly-flex ly-flex-col ly-flex-ali-center ly-flex-just-center">
        <p>商旺宝平台拥有海量热售新铺</p>
        <p>买铺投资，还在商旺宝</p>
      </div>
      <div class="form-info-btn ly-flex ly-flex-ali-center ly-flex-just-between">
        <div class="form-btn-item ly-flex ly-flex-col ly-flex-ali-center ly-flex-just-center">
          <a href="tel:400-6622-511" class="ly-flex ly-flex-col ly-flex-ali-center ly-flex-just-center"><p>
            点击拨打客服热线</p>
            <button>400-6622-511</button>
          </a>
        </div>
        <div class="form-btn-item ly-flex ly-flex-col ly-flex-ali-center ly-flex-just-center">
          <a
            href='https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzI0ODEzNzkxMA==&scene=110#wechat_redirect'
            class="ly-flex ly-flex-col ly-flex-ali-center ly-flex-just-center"><p>点击获取更多资讯</p>
            <button>商旺宝|商旺宝情报站</button>
          </a>
        </div>
      </div>
    </div>
    <!--区域选择开始-->
    <van-popup v-model="showPicker" position="bottom" >
      <van-picker
        show-toolbar
        :columns="popList"
        @cancel="addressClick"
        @confirm="onConfirm"
        @change="onChange"
      />
    </van-popup>
    <!--区域选择结束-->

    <!--选择弹窗开始-->
    <van-overlay :show="popShow" @click="popClick">
      <div class="wrapper" @click.stop>
        <div class="block ly-flex ly-flex-col ly-flex-ali-center ly-flex-just-between">
          <h1 class="block-title">
            提交成功
          </h1>
          <div class="block-text">
            <p>{{formCol.popData.name}}</p>
            <p>更多详询请致电全国客服热线：400-6622-511</p>
          </div>
          <div class="block-bottom ly-flex ly-flex-ali-center ly-flex-just-between">
            <div class="block-bottom-btn ly-flex ly-flex-ali-center ly-flex-just-center" @click="popClick" >
              <a href="javascript:;" :style="{backgroundColor:formCol.popData.colorOne}">
                返回
              </a>

            </div>
            <div class="block-bottom-btn ly-flex ly-flex-ali-center ly-flex-just-center" >
              <a
                href='https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzI0ODEzNzkxMA==&scene=110#wechat_redirect' :style="{backgroundColor:formCol.popData.colorTwo}">前往公众号</a>

            </div>
          </div>
        </div>
      </div>
    </van-overlay>
    <!--选择弹窗结束-->

  </div>
</template>

<script>
export default {
  props: {
    pageId: String,
    bgColor: String,
    formCol: Object
  },
  data () {
    return {
      popShow: false,
      showPicker: false,
      subMitFlag: false, /* 颜值阈值 */
      formLoadFlag: true, /* 提交阈值 */
      formData: {
        name: '', /* 姓名 */
        phone: '', /* 电话 */
        address: '', /* 地址 */
        acreage: '', /* 面积 */
        area: '', /* 区域 */
        suitableForFormats: '' /* 业态 */
      },
      phoneText: '联系电话',
      addressList: ['新城区', '碑林区', '莲湖区', '雁塔区', '灞桥区', '未央区', '阎良区', '临潼区', '长安区', '高陵区', '鄠邑区', '蓝田县', '周至县', '西咸新区', '曲江新区'],
      tagList: ['餐饮美食', '超市百货', '美容美发', '教育培训', '通信数码', '医疗保健', '服装鞋帽', '休闲娱乐', '家居建材', '宾馆酒店'],
      popListIndex: 0,
      popList: [], // 选择数据
      postApi: '' // 提交接口
    }
  },
  mounted () {
    document.getElementsByTagName('body')[0].style.setProperty('--color-primary', this.bgColor)
    this.pageId == 1 ? this.postApi = this.$api.postLookApi : this.postApi = this.$api.postRentApi
  },
  methods: {
    /* 地址选择 */
    addressClick (index) {
      this.popListIndex = index
      index == 0 ? this.popList = this.addressList : this.popList = this.tagList
      this.showPicker = !this.showPicker
    },
    /* 选择区域 */
    onChange (picker, value, index) {
      if (this.pageId == 1) {
        this.formData.address = value
      } else {
        this.popListIndex == 0 ? this.formData.area = value : this.formData.suitableForFormats = value
      }
    },
    /* 区域选择 */
    onConfirm (value) {
      this.showPicker = false
    },
    /* 表单提交 */
    formSubmit () {
      this.subMitFlag = true
      let reg = new RegExp(/^1[3,4,5,7,8,9]\d{9}$/)
      if (!reg.test(this.formData.phone)) {
        this.formData.phone = ''
        this.phoneText = '电话号码格式不正确'
      }
      if (this.pageId == 1) {
        if (this.formData.name != '' && this.formData.phone != '' && this.formData.address != '' && this.formData.acreage != '') {
          this.formLoadFlag = false
          this.$post(this.postApi, this.formData).then((res) => {
            if (res.code == 200) {
              this.formLoadFlag = true
              this.popClick()
            }
          })
        }
      } else {
        if (this.formData.name != '' && this.formData.phone != '' && this.formData.area != '' && this.formData.acreage != '' && this.formData.suitableForFormats != '') {
          this.formLoadFlag = false
          this.$post(this.postApi, this.formData).then((res) => {
            if (res.code == 200) {
              this.formLoadFlag = true
              this.popClick()
            }
          })
        }
      }
    },
    /* 关闭梦层 */
    popClick () {
      this.popShow = !this.popShow
    }
  }
}
</script>

<style  lang="scss">
  .data-form {
    .look-form {
      width: 568px;
      height: auto;
      margin: 0 auto;

      .look-form-item {
        width: 100%;
        margin-top: 30px;

        input {
          width: 100%;
          line-height: 70px;
          text-indent: 30px;
          border: 1px solid #9e9e9f;
          font-size: 28px;
          color: #888888;
        }

      }

      .look-form-item-hover {
        input::placeholder {
          color: red;
        }
      }

      .van-button {
        width: 100%;
        height: 80px;
        background: var(--color-primary);
        border: none;
        margin-top: 30px;
        font-size: 28px;
        color: #fff;
        letter-spacing: 5px;
      }

    }

    .form-info {
      width: 568px;
      margin: 0 auto;

      .form-text {
        margin: 0 auto;
        margin-top: 42px;
        font-size: 18px;
        color: #888888;
      }

      .form-info-btn {
        width: 100%;
        margin: 60px 0 80px 0;

        .form-btn-item {
          width: 50%;

          p {
            font-size: 18px;
            color: #888888;
            margin-top: 5px;
          }

          button {
            width: 214px;
            height: 40px;
            line-height: 40px;
            border-radius: 16px;
            margin-top: 24px;
            background: var(--color-primary);
            font-size: 18px;
            color: #fff;
            text-align: center;
          }
        }
      }
    }


    .van-picker{
      .van-picker__cancel{
        font-size:28px;
      }
      .van-picker__confirm{
        font-size:28px;
      }
      .van-picker-column__item{
        font-size:28px;
      }
    }


    .van-picker__toolbar {
      height: 80px;
    }

    .wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 750px;
      height: 100%;
    }

    .block {
      width: 690px;
      /*height: 439px;*/
      background-color: #fff;
      border-radius: 15px;

      .block-title {
        margin: 62px auto;
        font-size: 48px;
        font-weight: bold;
        color: var(--color-primary);
      }

      .block-text {
        padding: 0 10px;
        margin-bottom: 73px;

        p:first-child {
          font-size: 28px;
          font-weight: bold;
          color: var(--color-primary);
        }

        p:last-child {
          margin-top: 24px;
          font-size: 24px;
          color: rgb(153, 153, 153);
        }
      }

      .block-bottom {
        width: 100%;
        height: 122px;
        border-top: 1px solid #e3e3e3;

        .block-bottom-btn {
          width: 50%;
          height: 64px;

          a {
            display: block;
            width: 200px;
            height: 64px;
            line-height: 64px;
            border-radius: 64px;
            background: rgb(60, 81, 152);
            font-size: 28px;
            color: #fff;
            text-align: center;
          }
        }
        .block-bottom-btn:last-child {

          a {
            background: rgb(44, 61, 119);
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/dataForm.vue